import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sdg-popup-header',
  templateUrl: './sdg-popup-header.component.html',
  styleUrls: ['./sdg-popup-header.component.scss'],
})
export class SdgPopupHeaderComponent {
  @Input()
  title?: string;

  @Input()
  goalCode = '';

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output()
  close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
